module.exports = __webpack_public_path__ + "static/media/am.3bcfa4ad.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/am.svg
// module id = 2033
// module chunks = 0